@import url('https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400&family=Source+Code+Pro:wght@400;500;600&display=swap');

html {
  height: 100%;
}

body {
  margin: 0;
  font-family: 'Work Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  height: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

small {
  line-height: 1;
}

#root {
  height: 100%;
}

h4.ant-typography {
  margin: 0;
}

/* OVERRIDE FOR ReactMarkdown */
p {
  margin-top: 3px;
}

/* antd Overrides */
.ant-select-dropdown {
  overflow: visible !important;
}

/* A value being calculated goes quiet, rather than a spinner appearing beside it.
   Consumers: FieldLabel, ArBundleHeaderRow, ArTableAggregations. */
@keyframes calculatingValue {
  from { opacity: 0.75; }
  to { opacity: 0.25; }
}

.calculating-value {
  animation: calculatingValue 0.5s ease-in-out infinite alternate;
}

@media (prefers-reduced-motion: reduce) {
  .calculating-value {
    animation: none;
    opacity: 0.45;
  }
}

/* A field a point-in-time restore would change, tinted while the previewed
   moment is on screen (SYD-2450). Consumer: FieldUI, which joins this class onto
   ControlUI. The colour is colorPrimaryBg through the CSS variable antd v6 emits
   for it on every control's own root element — the same "a pending write will
   touch this" tint ArCell uses for a preview target. !important because the
   preview disables every control, and the disabled background antd sets carries
   the same specificity as this rule. */
.recovery-differing-value {
  background-color: var(--ant-color-primary-bg) !important;
}

.form-content-cap:empty {
  display: none;
}

/* antd BUG */
.ant-card-body::before, .ant-card-body::after {
  content: none !important;
}

.ant-tree-switcher {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ant-table-wrapper .ant-table-cell-fix-left {
  z-index: 4;
}

.ant-table-wrapper .ant-table-sticky-holder {
  z-index: 12 !important;
}

/* Drawer resize grip — geometry and colours come from drawerDraggerStyle */
.ant-drawer-resizable-dragger {
  background-image: linear-gradient(var(--drawer-dragger-grip), var(--drawer-dragger-grip));
}

.ant-drawer-resizable-dragger:hover,
.ant-drawer-resizable-dragger-dragging {
  background-image: linear-gradient(var(--drawer-dragger-grip-active), var(--drawer-dragger-grip-active));
}


/* Panel resize handle — geometry from the call site, states from here so no
   React state is needed for hover, focus or drag. */
.panel-resize-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ew-resize;
  touch-action: none;
  flex-shrink: 0;
}

.panel-resize-handle-grip {
  width: var(--panel-grip-width, 4px);
  height: var(--panel-grip-height, 32px);
  border-radius: var(--panel-grip-radius, 4px);
  background: var(--panel-grip-color);
  transition: background 0.2s ease;
}

.panel-resize-handle:hover .panel-resize-handle-grip,
.panel-resize-handle:focus-visible .panel-resize-handle-grip,
.panel-resize-handle:active .panel-resize-handle-grip {
  background: var(--panel-grip-color-active);
}

.panel-resize-handle:hover,
.panel-resize-handle:focus-visible,
.panel-resize-handle:active {
  border-inline-start-color: var(--panel-grip-color-active);
}

.panel-resize-handle:active {
  background: var(--panel-track-active, transparent);
}

/* Table column resize handle — per-instance geometry comes from the call site,
   which also hands over the two colours; the resting, hover, focus and drag
   states are resolved here so no component keeps a hover flag in React state.
   The drag colour is carried by `:hover`, not `:active`: the handle prevents the
   default on pointerdown, which suppresses the compatibility mouse events
   `:active` depends on, while hover follows the element that captured the
   pointer for as long as it holds it. */
.column-resize-handle {
  border-inline-end: 2px solid var(--column-resize-color);
  cursor: col-resize;
  transition: border-color 0.15s;
}

.column-resize-handle:hover,
.column-resize-handle:focus-visible,
.column-resize-handle:active {
  border-inline-end-color: var(--column-resize-color-active);
}
